module.exports = __webpack_public_path__ + "img/cheeks.575ec515.svg";